import { render, staticRenderFns } from "./LegalInformationsContent.vue?vue&type=template&id=2ef2160f&scoped=true"
import script from "./LegalInformationsContent.vue?vue&type=script&lang=js"
export * from "./LegalInformationsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2160f",
  null
  
)

export default component.exports